import React, { useState, useEffect } from 'react';
import { /*useMicVAD,*/ utils } from "@ricky0123/vad-react";
import { MicVAD } from "@ricky0123/vad-web";
import encodeWav from 'audiobuffer-to-wav';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import HamsterAnimation from '../../animation/loader';
import HamsterAnimationstill from '../../animation/stillloader';
import NoSleep from 'nosleep.js';

const MyComponentbeta = ({ userid, socketRef, contexto, setContexto }) => {
  const [audioList, setAudioList] = useState([]);
  const [autoken, setAutoken] = useState(null); // State to hold the token
  const { getAccessTokenSilently } = useAuth0();
  const [myvad, setMyVad] = useState(null); 
  const [listening, setListening] = useState(false);
  const [microphones, setMicrophones] = useState([]);
  const [selectedMic, setSelectedMic] = useState("");
  const [animationTrigger, setAnimationTrigger] = useState(false); // New state to control animation

  const handleContextSet = () => {
    setContexto(document.querySelector('.context-textarea').value);
    setAnimationTrigger(true); // Trigger animation
    setTimeout(() => setAnimationTrigger(false), 2000); // Reset animation trigger after the animation duration
  };
  //const [contexto, setContexto] = useState('');
  var noSleep = new NoSleep();
  

  useEffect(() => {
    let ignore = false;

    // Function to get the access token
    const getToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        if (!ignore) setAutoken(token);
      } catch (error) {
        if (!ignore) console.error("Error fetching access token:", error);
      }
    };

    // Get the token immediately and every 3 minutes thereafter
    getToken(); // Get the token on initial render
    const tokenInterval = setInterval(getToken, 180000); // Refresh token every 3 minutes

    // Clear interval on unmount
    return () => { 
      ignore = true; 
      clearInterval(tokenInterval); 
    };
  }, [getAccessTokenSilently]);
  useEffect(() => {
    
    const initializeVAD = async () => {
      if(selectedMic) {
      const vadInstance = await MicVAD.new({
        additionalAudioConstraints: {
          deviceId: selectedMic,
          echoCancellation: false,
          noiseSuppression: false,
          autoGainControl: true,
          sampleSize: "max",
          sampleRate: 44100,
        },
        onSpeechEnd: sendAudio,
        // ... other callbacks and options as needed ...
      });

      setMyVad(vadInstance);
    }
    };

    if(selectedMic) {
      initializeVAD();
    }

    return () => {
      myvad?.pause(); // Ensure to stop the VAD when component unmounts
    };
  }, [selectedMic, contexto]);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        const mics = devices.filter(device => device.kind === 'audioinput');
        setMicrophones(mics);
        if (mics.length > 0) {
          setSelectedMic(mics[0].deviceId); // Default to the first microphone
        }
        console.log("Microphones:", mics);
      })
      .catch(error => console.error("Error fetching devices:", error));
  }, []);
  /*const sendAudio = async (audioFloat32Array) => {
    const wavBuffer = utils.encodeWAV(audioFloat32Array);
    const blob = new Blob([wavBuffer], { type: 'audio/wav' });
    const formData = new FormData();
    formData.append('file', blob);
    formData.append('user_id', userid);
  
    try {
      const headers = {Authorization: `Bearer ${autoken}`,};
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/audio`, formData, { headers }).then((response) => {
        console.log("User id in transcription:", response);
    })
      const base64 = utils.arrayBufferToBase64(wavBuffer);
      const url = `data:audio/wav;base64,${base64}`;
      setAudioList((old) => [url, ...old]);
    } catch (error) {
      console.error('Error sending audio data:', error);
    }
  };*/
  const handleMicChange = (e) => {
    setSelectedMic(e.target.value);
  };

  
  const sendAudio = async (audioFloat32Array) => {
    console.log("sending audio");
    const logs = JSON.parse(localStorage.getItem('logs') || '[]');
    
    let lastMessage;
    
    if (logs.length >= 3) {
        // If there are three or more logs, use the last three entries.
        lastMessage = logs.slice(-3).join("\n");
    } else {
        // If there are fewer than three logs, use the last message or an empty string.
        lastMessage = localStorage.getItem('lastMessage') || '';
    }
    console.log("lastMessage", lastMessage);
    const wavBuffer = utils.encodeWAV(audioFloat32Array);
    const blob = new Blob([wavBuffer], { type: 'audio/wav' });

    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
        // Convert the lastMessage to an ArrayBuffer
        const encoder = new TextEncoder();
        console.log("contexto", contexto);
        const metadataBuffer = encoder.encode(contexto+"\n\n"+lastMessage);
        const metadataSizeBuffer = new ArrayBuffer(4);
        new DataView(metadataSizeBuffer).setUint32(0, metadataBuffer.byteLength, true); // true for little endian

        // Convert blob to ArrayBuffer
        const audioArrayBuffer = await blob.arrayBuffer();

        // Combine metadataSize, metadata, and audio into a single ArrayBuffer
        const combinedBuffer = new Uint8Array(metadataSizeBuffer.byteLength + metadataBuffer.byteLength + audioArrayBuffer.byteLength);
        combinedBuffer.set(new Uint8Array(metadataSizeBuffer), 0);
        combinedBuffer.set(new Uint8Array(metadataBuffer), metadataSizeBuffer.byteLength);
        combinedBuffer.set(new Uint8Array(audioArrayBuffer), metadataSizeBuffer.byteLength + metadataBuffer.byteLength);

        // Send the combined ArrayBuffer over WebSocket
        socketRef.current.send(combinedBuffer.buffer);
    }
};

  

  /*const vad = useMicVAD({
    startOnLoad: false,
    additionalAudioConstraints: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      sampleSize: 24,
    },
    onSpeechEnd: sendAudio,
  });*/
  
/*
  const activateVAD = () => {
    console.log('vad toggled');
    console.log(vad);
    vad.toggle();
  };*/

  const toggleVAD = () => {
    if (myvad) {
      myvad.listening ? myvad.pause() : myvad.start();
      setListening(myvad.listening);
      console.log(myvad.listening);
      if (myvad.listening) {

        document.addEventListener('click', function enableNoSleep() {
          document.removeEventListener('click', enableNoSleep, false);
          noSleep.enable();
        }, false);
      } else {
        noSleep.disable();
        console.log('no sleep disabled');
      }

    }

  };

/*list of audio devices*/


  return (
    <>
    
    
    <select className="microphone-select" onChange={handleMicChange} value={selectedMic}>
        {microphones.map(mic => (
          <option key={mic.deviceId} value={mic.deviceId}>
            {mic.label || `Microphone ${mic.deviceId}`}
          </option>
        ))}
      </select>
      
      <div className="context-container">
        <textarea className='context-textarea' placeholder='ej. charla sobre historia de Guatemala...'></textarea>
        <button className={`context-set-button ${animationTrigger ? 'context-set-button-animate' : ''}`} onClick={handleContextSet}>Establecer Contexto</button>
      </div>
      
      

       
    <div className='content-wrapper-header2'>
      
      {userid=== null && <div><span style={{color: 'red'}}>not ready yet</span></div>}
      <div>{listening ? <HamsterAnimation/> : <HamsterAnimationstill/>}</div>
      <button className={`content-button status-button ${listening ? 'listening' : 'not-listening'} open`} onClick={toggleVAD}>
        {listening ? <span style={{color: 'red'}}>stop</span> : <span style={{color: 'rgba(0, 255, 0)'}}>start</span>}
      </button>
      <h3>{listening ? <span style={{color: 'rgba(0, 255, 0)'}}>detectando voz</span>: "detección de voz detenida"}</h3>

    </div>
    </>
  );
};

export default MyComponentbeta;
